"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasUpfrontFields = exports.isOauth = exports.isPublic = exports.isInvite = exports.isPremium = exports.isHidden = exports.isFeatured = exports.isDeprecated = exports.isBuiltIn = exports.isBeta = void 0;
var lodash_1 = require("lodash");
var isPathTrue = function (path, service) {
    return Boolean(lodash_1.get(service, path, null));
};
var isAnyPathTrue = function (paths, service) {
    return paths.some(function (path) { return isPathTrue(path, service); });
};
// The multiple keys here represent legacy data structure and the updated
// GraphQL equivalent
exports.isBeta = lodash_1.partial(isAnyPathTrue, ['beta', 'isBeta']);
exports.isBuiltIn = lodash_1.partial(isAnyPathTrue, ['builtIn', 'isBuiltIn']);
exports.isDeprecated = lodash_1.partial(isAnyPathTrue, [
    'deprecated',
    'isDeprecated',
]);
exports.isFeatured = lodash_1.partial(isAnyPathTrue, ['featured', 'isFeatured']);
exports.isHidden = lodash_1.partial(isAnyPathTrue, ['hidden', 'isHidden']);
exports.isPremium = lodash_1.partial(isAnyPathTrue, ['premium', 'isPremium']);
exports.isInvite = lodash_1.partial(isAnyPathTrue, ['invite_app', 'isInvite']);
exports.isPublic = lodash_1.partial(isAnyPathTrue, ['public', 'isPublic']);
exports.isOauth = function (service) {
    var authType = lodash_1.get(service, 'authType', null);
    var oauthService = lodash_1.get(service, ['meta', 'oauth'], false);
    return authType === 'oauth' || oauthService;
};
exports.hasUpfrontFields = function (service) {
    return Boolean(service.hasUpfrontFields) || !lodash_1.isEmpty(service.upfront_fields);
};
